module.exports = __webpack_public_path__ + "img/3-2.234d6727.png";